import {removeNullProperties} from "./remove-null-properties.function";
export const createFormData = (object: Object): FormData => {
    let formData: FormData = new FormData();
    for (const prop in object) {
        if(!object.hasOwnProperty(prop)) { continue; }
        formData.append(prop, object[prop]);
    }
    return formData;
}